import { Link, useNavigate } from "react-router-dom";
import { useApp } from "../context/AppContext";
import { Heart, LogOut, Globe2, User } from "lucide-react";

export default function Header() {
  const { t, lang, toggleLang, user, logout } = useApp();
  const nav = useNavigate();

  return (
    <header className="sticky top-0 z-40 backdrop-blur-md bg-[#FAF7F2]/85 border-b border-[#E7E0D5]">
      <div className="max-w-6xl mx-auto px-5 py-3.5 flex items-center justify-between gap-4">
        <Link to="/" data-testid="link-home" className="flex items-center gap-2.5 group">
          <img
            src="/logo.png?v=2"
            alt="Planificador de Planes"
            className="w-11 h-11 object-contain group-hover:rotate-6 transition-transform"
          />
          <span className="font-bold text-lg tracking-tight text-stone-900">{t.appName}</span>
        </Link>
        <nav className="flex items-center gap-1 sm:gap-2">
          <button
            data-testid="button-toggle-lang"
            onClick={toggleLang}
            className="text-xs font-mono uppercase tracking-wider px-2.5 py-1.5 rounded-full border border-[#E7E0D5] hover:bg-white transition-colors flex items-center gap-1.5"
          >
            <Globe2 className="w-3.5 h-3.5" />
            {lang === "es" ? "ES" : "EN"}
          </button>
          {user ? (
            <>
              <Link
                to="/favorites"
                data-testid="link-favorites"
                className="text-sm px-3 py-1.5 rounded-full hover:bg-white text-stone-700 flex items-center gap-1.5 transition-colors"
              >
                <Heart className="w-4 h-4" />
                <span className="hidden sm:inline">{t.favorites}</span>
              </Link>
              <button
                data-testid="button-logout"
                onClick={() => { logout(); nav("/"); }}
                className="text-sm px-3 py-1.5 rounded-full hover:bg-white text-stone-700 flex items-center gap-1.5 transition-colors"
              >
                <LogOut className="w-4 h-4" />
                <span className="hidden sm:inline">{t.logout}</span>
              </button>
            </>
          ) : (
            <>
              <Link
                to="/login"
                data-testid="link-login"
                className="text-sm px-3 py-1.5 rounded-full hover:bg-white text-stone-700 flex items-center gap-1.5 transition-colors"
              >
                <User className="w-4 h-4" />
                <span className="hidden sm:inline">{t.login}</span>
              </Link>
              <Link
                to="/register"
                data-testid="link-register"
                className="text-sm px-3 py-1.5 rounded-full bg-stone-900 text-white hover:bg-stone-700 transition-colors"
              >
                {t.signup}
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
}
